import styled from 'styled-components';
import { hexToRGB } from '@/styles/helpers';
import { fpx } from '../../../../styles/fluid';

export const ScGameCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${fpx(10)};
  width: ${fpx(320)};
  padding: ${fpx(4.7)};
  border-radius: ${fpx(12)};
  background: ${({ theme }) => hexToRGB(theme.blackColor, 0.5)};

  @media (orientation: portrait) {
    position: relative;
    z-index: 2;
    width: ${fpx(220)};
  }
`;

export const ScGameCardImg = styled.img`
  width: ${fpx(94)};
  height: ${fpx(94)};
  flex-shrink: 0;
  border-radius: ${fpx(8)};
  object-fit: cover;

  @media (orientation: portrait) {
    width: ${fpx(60)};
    height: ${fpx(60)};
    border-radius: ${fpx(7)};
  }
`;

export const ScGameCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${fpx(12)};
  color: #fff;

  .name {
    font-family: 'Inter', sans-serif;
    font-size: ${fpx(18)};
    font-weight: 900;
    color: #FCD202;
    line-height: ${fpx(22)};
    text-transform: uppercase;
  }

  .provider {
    font-family: 'Inter', sans-serif;
    font-size: ${fpx(16)};
    font-weight: 500;
    line-height: ${fpx(19)};
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.5)};
  }

  @media (orientation: portrait) {
    gap: ${fpx(8)};

    .name {
      font-size: ${fpx(14)};
      line-height: ${fpx(17)};
      letter-spacing: 0.84px;
    }

    .provider {
      font-size: ${fpx(12)};
      line-height: ${fpx(15)};
    }
  }
`;
